import { browser } from '$app/environment'
import { renderTick } from '../flip'

export function getScrollBuffer() {
      //for SSR
      if (!browser)
            return () => {
                  return
            }

      const element = document.documentElement
      const isEnd = element.clientHeight + element.scrollTop == element.scrollHeight
      const scroll = element.scrollTop

      return async () => {
            await renderTick()

            const delta = element.scrollHeight - element.clientHeight

            if (!isEnd && scroll == 0) return

            if (!isEnd) {
                  element.scrollTop = scroll
                  return
            }

            element.scrollTop = delta

            return
      }
}
